import store from "../../../../../store";
//import lodash from "lodash";

export const callHazSubStance = ({ searchQuery }) => store.dispatch(`resource/v1/master/hazSubStance/cacheFindAll`, { value: searchQuery, where: [] });
export const callHazDiscussResult = () => store.dispatch(`resource/v1/master/lookup/cacheFindAllByGroup`, { group: 'HAZ_DISCUSS_RESULT' });
export const callHazDiscussDofControls = () => store.dispatch(`resource/v1/master/lookup/cacheFindAllByGroup`, { group: 'HAZ_DISCUSS_DOF_CONTROL' })

export async function hazSubStanceResult ({ data }) {
    const { useForm } = data;
    const { modelRef } = useForm;
    const hazSubStances = (await Promise.resolve(callHazSubStance({})));
    const hazDiscussDofControls = (await Promise.resolve(callHazDiscussDofControls({})));

    modelRef.refHazDiscussTemp.mainSubStances.forEach((mainSubStance) => {
        //check and update
        const subStanceDb = hazSubStances.find((e) => e.name == mainSubStance.otherSubStance);
        if (subStanceDb && mainSubStance.refSubStance.refType == null) {
            mainSubStance.refSubStance = subStanceDb;
            mainSubStance.otherSubStance = null;
        }
        //stamp dof control each main sub stance
        if (mainSubStance.refSubStance?.refType?.key == 'media') {
            mainSubStance.dofControl = hazDiscussDofControls.find(e => e.key == '5').value;
        } else if (mainSubStance.refSubStance?.refSpecies?.key == '1') {
            mainSubStance.dofControl = hazDiscussDofControls.find(e => e.key == '1').value;
        } else if (mainSubStance.refSubStance?.refSpecies?.key == '2') {
            mainSubStance.dofControl = hazDiscussDofControls.find(e => e.key == '2').value;
        } else if (mainSubStance.refSubStance?.refSpecies?.key == '3') {
            mainSubStance.dofControl = hazDiscussDofControls.find(e => e.key == '3').value;
        } else if (mainSubStance.refSubStance?.refSpecies?.key == '4') {
            mainSubStance.dofControl = hazDiscussDofControls.find(e => e.key == '4').value;
        } else if (!subStanceDb && mainSubStance.refSubStance.refType == null) {
            mainSubStance.dofControl = hazDiscussDofControls.find(e => e.key == '6').value;
        }
    });
    return data;
}

export async function processResult ({ data }) {
    data = await hazSubStanceResult({ data });
    const { useForm } = data;
    const { modelRef } = useForm;
    const hazDiscussResults = await Promise.resolve(callHazDiscussResult({}));
    //select sub stance that in has most value
    if (modelRef.refHazDiscussTemp?.refMainSubStance?.find(e => e.refType?.key == "4")) {
        modelRef.refHazDiscussTemp.mainSubStance = modelRef.refHazDiscussTemp?.refMainSubStance?.find(e => e.refType?.key == "4");
    } else if (modelRef.refHazDiscussTemp?.refMainSubStance?.find(e => e.refType?.key == "3")) {
        modelRef.refHazDiscussTemp.mainSubStance = modelRef.refHazDiscussTemp?.refMainSubStance?.find(e => e.refType?.key == "3");
    } else if (modelRef.refHazDiscussTemp?.refMainSubStance?.find(e => e.refType?.key == "2")) {
        modelRef.refHazDiscussTemp.mainSubStance = modelRef.refHazDiscussTemp?.refMainSubStance?.find(e => e.refType?.key == "2");
    } else if (modelRef.refHazDiscussTemp?.refMainSubStance?.find(e => e.refType?.key == "1")) {
        modelRef.refHazDiscussTemp.mainSubStance = modelRef.refHazDiscussTemp?.refMainSubStance?.find(e => e.refType?.key == "1");
    } else {
        modelRef.refHazDiscussTemp.mainSubStance = null; 
    }
    

    //stamp haz discuss result
    if (modelRef.refHazDiscussTemp.refMainObjective.value != "3") {
        modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "2");
    } else if (!modelRef.refHazDiscussTemp?.mainSubStance && 
        (modelRef.refHazDiscussTemp.refMainSubStance?.find(e => e.refSubStance?.refType?.key == "media"))) {
        modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "3");
    } else if (modelRef.refHazDiscussTemp?.refMainSubStance?.find(e => e.refSpecies?.key == "4")) {
        modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "4");
    } else if (modelRef.refHazDiscussTemp?.refMainOperation?.key == "4" && modelRef.refHazDiscussTemp?.refSubOperation?.key == "3" ) {
        modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "5");
    } else if (modelRef.refHazDiscussTemp?.refSubOperation?.key == "4") {
        if (["1", "3"].includes(modelRef.refHazDiscussTemp?.refMainOperation?.key)) {
            modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "6");
        } else {
            modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "7");
        }
    } else if (modelRef.refHazDiscussTemp?.refSubOperation?.key == "2") {
        modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "8");
    } else if (modelRef.refHazDiscussTemp?.refMainSubStance?.mainSubStance.refSubStance?.refSpecies?.key == "1") {
        modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "9");
    } else if (["2", "3"].includes(modelRef.refHazDiscussTemp?.refMainSubStance?.mainSubStance?.refSubStance?.refSpecies?.key))  {
        modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "10");
    }  else if (!modelRef.refHazDiscussTemp?.refMainSubStance?.mainSubStance) {
        modelRef.refHazDiscussTemp.refResult = hazDiscussResults.find(e => e.key == "1");
    }
    return data;
}
